import { render, staticRenderFns } from "./Min-Max.vue?vue&type=template&id=9c4488e2"
import script from "./Min-Max.vue?vue&type=script&lang=js"
export * from "./Min-Max.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports